import f from './functions.js'

var Axios = require('axios');


var sha1 = require('sha1');
var { parseerror } = require('./error')

import dbstorage from "./dbstorage.js";
import _ from 'underscore';
import {Promocode, Task, Story, Lesson, LessonProgress} from './kit.js'

var FormDataRequest = function (core = {}, url, system) {

	var self = this

	self.fetch = function (to, formData, p) {
		const headers = { 'content-type': 'multipart/form-data' };

		return (core.user ? core.user.extendA({ formData, system }) : Promise.resolve()).then(r => {

			return Axios({
				baseURL: url,
				url: to || '',
				data: formData,
				method: 'post',
				headers,
			}).then(r => {

				if (f.deep(r, 'data.errors')) {
					return Promise.reject(parseerror({
						code: 500,
						errors: r.data.errors
					}))
				}


				return Promise.resolve(r.data)
			})
		})

	}

}

var FormDataRequestAu_Headers = function (core = {}, url, system) {

	var self = this

	self.fetch = function (to, formData, p) {
		const headers = { 'content-type': 'multipart/form-data' };

		return (core.user ? core.user.extendA({ headers, system }) : Promise.resolve()).then(r => {

			return Axios({
				baseURL: url,
				url: to || '',
				data: formData,
				method: 'post',
				headers,
			}).then(r => {

				if (f.deep(r, 'data.errors')) {
					return Promise.reject(parseerror({
						code: 500,
						errors: r.data.errors
					}))
				}


				return Promise.resolve(r.data)
			})
		})

	}

}

var Request = function (core = {}, url, system) {
	var self = this

	var loading = {}

	var timeout = function (ms, promise, controller) {

		return new Promise((resolve, reject) => {
			const timer = setTimeout(() => {

				if (controller.signal.dontabortable) {
					return
				}

				if (controller) {
					controller.abort()
				}
			}, ms)

			promise.then(value => {

				clearTimeout(timer)
				resolve(value)

			}).catch(reason => {

				clearTimeout(timer)
				reject(reason)

			})
		})
	}

	var direct = function (url, data, p) {

		if (!p) p = {}

		if (typeof AbortController != 'undefined') {
			var controller = p.controller || (new AbortController())

			var time = p.timeout || 60000

			if (typeof window != 'undefined' && window.cordova) {
				time = time * 2
			}

			return timeout(time, directclear(url, data, controller.signal, p), controller)
		}
		else {
			return directclear(url, data, null, p)
		}


	}

	var directclear = function (url, data, signal, p) {

		if (!p) p = {}

		if (!data)
			data = {}

		var headers = _.extend({
			'Accept': 'application/json',
			'Content-Type': 'application/json;charset=utf-8'
		}, p.headers || {})


		var er = false
		var status = 0
		var token = ''


		return (core.user ? core.user.extendA({ headers, data, system }) : Promise.resolve()).then(r => {

			var parameters = {

				method: p.method || 'POST',
				mode: 'cors',
				headers: headers,
				signal: signal
			}

			
			if (parameters.method == 'POST') {
				if (p.urldata){

					const us = new URLSearchParams();

					_.each(data, (d, i) => {
						us.append(i, d);
					})

					parameters.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'

					parameters.body = us
				}
				
				else{
					parameters.body = JSON.stringify(data)
				}
				
			}


			if (parameters.method == 'GET') url = url + (url.indexOf('?') > -1 ? '&' : '?') + new URLSearchParams(data)

			return fetch(url, parameters)

		}).then(response => {

			if (signal)
				signal.dontabortable = true

			if (!response.ok) {
				er = true
			}

			var json = {}

			status = response.status

			const contentType = response.headers.get("content-type");

			token = response.headers.get("Token");

			if(p.blob){
				return response.blob()
			}


			if (contentType && contentType.indexOf("application/json") !== -1) {

				return response.json()

			} else {
				return response.text().then(text => {

					return {
						Message: text,
					}

				});
			}

		}).then(result => {

			if(p.blob) {
				return Promise.resolve(result)
			}

			if(!_.isObject(result)){
				result = {
					Message : result
				}
			}

			result.code = status

			if (result.result == 'failed') {
				result.code = 500
				result.Error = result.errors
				er = true
			}

			if (result.AuthSession && result.AuthSession.Error) { /// oldpct
				result.code = 500
				result.Error = result.AuthSession.Error
				er = true
			}

			if (er) {
				return Promise.reject(parseerror(result))
			}

			else {

				if (!result.jwt)
					result.jwt = token

				core.user.extendU(result, system)
			}

			var data = (result || {}).data || result || {}

			return Promise.resolve(data)

		}).catch(e => {


			if (e && e.toString() && e.toString().indexOf('Failed to fetch') > -1) {
				e.code = 20
			}

			return Promise.reject(e)
		})
	}

	var doublePreventRequest = function (path, data, p) {
		var datahash = sha1(path + JSON.stringify(data))

		if (loading[datahash]) {
			return loading[datahash]
		}

		loading[datahash] = direct(path, data, p).then((r) => {
			delete loading[datahash]
			return Promise.resolve(r)
		}).catch(e => {
			delete loading[datahash]
			return Promise.reject(e)
		})

		return loading[datahash]
	}

	self.fetch = function (path, data, p) {

		if (!path) path = ''

		return doublePreventRequest(url ? (url + (path.indexOf('?') == 0 ? '' : '/') + path) : path, data, p)
	}

	return self
}

var ApiWrapper = function (core = {}, platform = "SNIPPITY") {

	var self = this;

	var cache = {}
	var storages = {}
	var blockNotify = false

	self.appid = core.appid
	self.platform = platform
	self.kt = {Promocode, Task, Story, Lesson, LessonProgress}


	self.prepare = function () {
		return Promise.all(_.map(dbmeta, (mf) => {
			return getstorage(mf())
		})).catch(e => {

			return Promise.resolve()
		})
	}

	var dbmeta = {

		system: function () {
			return {
				storage: 'system',
				time: 60 * 60 * 148,
				version: 6
			}
		},

		stories: function () {
			return {
				storage: 'stories',
				time: 60 * 60 * 148,
				version: 2
			}
		},

		lessonslight: function () {
			return {
				storage: 'lessonslight',
				time: 60 * 60 * 12,
				version: 2
			}
		},

		lessons: function () {
			return {
				storage: 'lessons',
				time: 60 * 60 * 148,
				version: 2,

				checkRefreshData : function(d){

					if(d){
						if(d.status == 'processing') return true

						if(_.isArray(d)){
							if(_.find(d, (l) => {
								return l.status == 'processing'
							})) return true
						}
					}
					
				}
			}
		},

		progress: function () {
			return {
				storage: 'progress',
				time: 1 * 60,
				version: 2
			}
		},

		earnings: function () {
			return {
				storage: 'earnings',
				time: 60 * 20,
				version: 2
			}
		},
	}

	var address = 'https://' + process.env.VUE_APP_SERVER 

	var requests = {
		api: new Request(core, address, 'snippity'),
		default: new Request(core)
	}

	self.server = address

	var liststorage = {}

	var waitonline = function () {

		if (!core || !core.waitonline) {
			return Promise.resolve()
		}

		return core.waitonline()

	}

	var prepareliststorage = function (data, system, to, p) {

		liststorage[system] || (liststorage[system] = {})
		liststorage[system][to] || (liststorage[system][to] = {})

		var datahash = ''

		_.each(data, function (v, k) {
			if (k != p.from && k != p.to && v && k != p.includeCount) datahash += JSON.stringify(v)
		})

		datahash = sha1(datahash)

		liststorage[system][to][datahash] || (liststorage[system][to][datahash] = {
			count: undefined,
			data: {}
		})


		return datahash
	}

	var getloaded = function (datahash, data, system, to, p) {

		var _fr = data[p.from] || 0
		var _count = data[p.count]

		if (p.bypages) _fr = (_fr * _count)


		var storage = liststorage[system][to][datahash]

		var loaded = _.filter(storage.data, function (e, i) {

			if(typeof _count == 'undefined') return true

			if (i >= _fr && (i < _count + _fr)) {
				return true
			}
		})

		var flength = _.filter(storage.data, function (e, i) {
			return e
		}).length

		var r = {
			data: loaded,
			count: storage.count,
			last: _.isEmpty(storage.data) ? undefined : _.max(_.map(Object.keys(storage.data), v => Number(v))),
			first: _.isEmpty(storage.data) ? undefined : _.min(_.map(Object.keys(storage.data), v => Number(v)))
		}



		if (flength == storage.count) return r

	

		if (typeof _count != 'undefined' && _count == loaded.length) return r

		return null

	}

	var paginatedrequest = function (data, system, to, p) {

		if (!p) p = {}
		if (!data) data = {}

		p.from || (p.from = "From")
		p.count || (p.count = "To")
		p.includeCount || (p.includeCount = "Count")

		var datahash = prepareliststorage(data, system, to, p)

		if (p.refresh) {

			liststorage[system][to][datahash].data = []
			liststorage[system][to][datahash].count = undefined

		}

		var loaded = getloaded(datahash, data, system, to, p)

		if (loaded) return Promise.resolve(loaded)

		if (!liststorage[system][to][datahash].count && !p.countLater) data[p.includeCount] = true


		return request(data, system, to, p).then(r => {

			if (r.Pagination) r.pagination = r.Pagination
			if (r.Records) r.records = r.Records

			if (r.pagination) {
				r.count = (typeof r.pagination.total != 'undefined' ? r.pagination.total : 0) || 
					(typeof r.pagination.Total != 'undefined' ? r.pagination.Total : 0)
			}

			prepareliststorage(data, system, to, p) /// async. maybe clear

			if (!data[p.from]) data[p.from] = 0

			_.each(r.records || [], (e, i) => {
				var c = 0

				if (p.bypages) { c = data[p.from] * data[p.count] + i } else { c = data[p.from] + i }

				liststorage[system][to][datahash].data[c] = e
			})

			if (typeof r.count != 'undefined' && (data[p.includeCount] || p.countLater)){
				liststorage[system][to][datahash].count = r.count
			}
				

			var loaded = getloaded(datahash, data, system, to, p)

			if (!loaded) return Promise.reject('notloaded')

			return Promise.resolve(loaded)
		}).catch(e => {
			console.error(e)

			return Promise.reject(e)
		})

	}

	var getstorage = function (p) {


		if (!storages[p.storage]) {
			return dbstorage(p.storage, p.version || 1, p.time).then(storage => {
				storages[p.storage] = storage

				return Promise.resolve(storage)
			})
		}

		return Promise.resolve(storages[p.storage])
	}

	var dbdividerequest = function (data, system, to, p = {}) {

		if (!p.storageparameters) return Promise.reject('p.storageparameters')
		if (!p.storageparameters.divide) return Promise.reject('p.storageparameters.divide')

		var ids = data[p.storageparameters.divide.requestIndex]

		return getstorage(p.storageparameters).catch(e => {
			return Promise.resolve(null)
		}).then(storage => {


			var loaded = {}
			var needtoload = []

			return Promise.all(

				_.map(ids, (id) => {

					if(!storage){
						needtoload.push(id)
						return Promise.resolve()
					}

					try{

						return storage.get(id).catch(e => {
							return Promise.resolve()
						}).then(r => {


							if (r) {
								loaded[id] = r
							}
							else {
								needtoload.push(id)
							}

							return Promise.resolve()
						})

					}

					catch(e){
						needtoload.push(id)

						return Promise.resolve()
					}
				})

			).then(() => {


				if (!needtoload.length) {
					return f.ep()
				}

				data[p.storageparameters.divide.requestIndex] = needtoload

				return request(data, system, to, p).then(r => {
					var data = r

					if (p.storageparameters.divide.path) data = f.deep(r, p.storageparameters.divide.path)

					_.each(data, (obj) => {

						var index = obj[p.storageparameters.divide.getloaded]


						if (index) {
							loaded[index] = obj

							if (storage){
								storage.set(index, obj).catch(e => {
								})
							}
							
						}


					})

					return Promise.resolve()
				})
			}).then(() => {
				var result = {}

				if (p.storageparameters.divide.path)
					f.deepInsert(result, p.storageparameters.divide.path, _.toArray(loaded))
				else
					result = loaded

				return Promise.resolve(result)
			})

		})


	}

	var dbaction = function (datahash, action, p = {}) {

		var _storage = null

		return (p.storageparameters ? getstorage(p.storageparameters) : f.ep()).catch(e => {
			return Promise.resolve(null)
		}).then(storage => {

			_storage = storage

			try{

				if (storage && !p.refreshDb) {
					return storage.get(datahash).then((r) => {

						if (p.storageparameters.checkRefreshData && p.storageparameters.checkRefreshData(r)){
							return Promise.resolve()
						}

						return Promise.resolve(r)

					}).catch(e => {
						return Promise.resolve()
					})
				}

			}

			catch(e){
				return Promise.resolve()
			}


			return Promise.resolve()

		}).then(cached => {
			

			if (!cached) {

				/// return request(data, system, to, p).then(r => {

				return action().then(r => {
					if (_storage) {
						return _storage.set(datahash, r, p.storageparameters.invalidate).then(() => {

							return Promise.resolve(r)

						})
					}
					return Promise.resolve(r)
				})

			}

			return Promise.resolve(cached)

		})
	}

	var dbrequest = function (data, system, to, p) {

		var datahash = ''
		var hash = system + to

		if(p.storageparameters && p.storageparameters.excludeParameters){
			var pdata = {}

			_.each(data, (d, i) => {
				if(!p.storageparameters.excludeParameters[i]){
					pdata[i] = d
				}
			})

			datahash = sha1(hash + JSON.stringify(pdata))
		}
		else{


			datahash = sha1(hash + JSON.stringify(data))
		}
		
		


		return dbaction(datahash, () => {

			if(p.payloadChange) data = p.payloadChange(data)

			return (requests[system] || requests['default']).fetch(to, data, p).then(r => {

				if(p.transformResponse) p.transformResponse(r)

				return Promise.resolve(r)
			})
		}, p)

	}

	var request = function (data, system, to, p = {}, attempt) {

		var alreadyLoaded = []


		if (!attempt) attempt = 0



		if (p.vxstorage && p.vxstorage.index && core.vxstorage) {
			var r = core.vxstorage.get(p.vxstorage.index, p.vxstorage.type)

			if (r) return Promise.resolve(r)
		}

		var breakLoading = false

		if (p.vxstorage && p.vxstorage.getloaded && core.vxstorage) {

			if (!p.vxstorage.one) {

				alreadyLoaded = _.filter(_.map(data[p.vxstorage.getloaded], function (index) {
					return core.vxstorage.get(index, p.vxstorage.type)
				}), (r) => {
					return r
				})

				data[p.vxstorage.getloaded] = _.filter(data[p.vxstorage.getloaded], (index) => {
					return !_.find(alreadyLoaded, (obj) => {
						return obj[core.vxstorage.index(p.vxstorage.type)] == index
					})
				})

				if (!data[p.vxstorage.getloaded].length) {

					breakLoading = true

				}
			}

			else {

				breakLoading = true

				alreadyLoaded = core.vxstorage.get(p.vxstorage.getloaded, p.vxstorage.type)

				//if (r) return Promise.resolve(r)
			}

			if (breakLoading) {
				var r = {}


				if (p.vxstorage.path) {
					f.deepInsert(r, p.vxstorage.path, alreadyLoaded)
				}
				else {
					r = alreadyLoaded
				}

				if (r) return Promise.resolve(r)
			}

		}

		if (p.preloader && core.store) {
			core.store.commit('globalpreloader', true)
		}

		return waitonline().then(() => {

			data || (data = {})

			return dbrequest(data, system, to, p).then(r => {

				//return (requests[system] || requests['default']).fetch(to, data, p).then(r => {

				if (p.kit) {
					var dk = r

					if (p.kit.path) {
						dk = f.deep(dk, p.kit.path) || (p.kit.one ? null : [])
					}


					if (p.kit.one) {
						dk = new p.kit.class(dk)
					}
					else {
						dk = _.map(dk, (d) => { return new p.kit.class(d) })
					}

					if (p.kit.path) {
						f.deepInsert(r, p.kit.path, dk)
					}
					else {
						r = dk
					}

				}

				if (p.vxstorage && core.vxstorage) {

					if(!p.vxstorage.setcustom){
						var ds = r

						if (p.vxstorage.path) ds = f.deep(ds, p.vxstorage.path) || (p.vxstorage.one ? null : [])

						if (p.vxstorage.one) {
							var stored = core.vxstorage.set(ds, p.vxstorage.type)
						}
						else {

							var stored = core.vxstorage.sets(ds, p.vxstorage.type)

							if (p.vxstorage.getloaded)
								stored = stored.concat(alreadyLoaded)

						}

						if (p.vxstorage.path) {
							f.deepInsert(r, p.vxstorage.path, stored)
						}
						else {
							r = stored
						}
					}
					else{
						r = p.vxstorage.setcustom(r)
					}

					

				}

				if (p.showStatus && core.store) {
					core.store.commit('icon', {
						icon: 'success',
					})
				}

				return Promise.resolve(r)

			}).catch(e => {

				console.error(e, e.code)

				if(e != 'stopped'){

					if (attempt < 3 && e && e.code == 20) {

						if (!attempt && !blockNotify && core.notifier){

							core.notifier.simplemessage({
								icon: "fas fa-wifi",
								title: "Please wait",
								message: "Loading takes longer than usual"
							})

							blockNotify = true

							setTimeout(() => {
								blockNotify = false
							}, 30000)

						}
							

						return new Promise((resolve, reject) => {

							attempt++

							setTimeout(function () {
								request(data, system, to, p, attempt).then(r => {
									return resolve(r)
								}).catch(e => {
									return reject(e)
								})

							}, 1000)
						})

					}

					if (core.store && (p.showStatus || p.showStatusFailed)) {
						core.store.commit('icon', {
							icon: 'error',
							message: e.error
						})
					}

				}

				return Promise.reject(e)

			}).finally(() => {
				if (core.store && p.preloader) {
					core.store.commit('globalpreloader', false)
				}
			})


		})


	}

	var invalidateStorageType = function (type, updated) {
		if (!storages[type]) return Promise.resolve()

		return storages[type].invalidateMany(updated)
	}

	var invalidateStorage = function (inv) {
		return Promise.all(_.map(inv, (item) => {

			return Promise.all(_.map(item.type, (type) => {
				return invalidateStorageType(type, item.updated)
			}))

		}))
	}

	self.invalidateDb = function (dbindex, updated, data) {
		if (storages[dbindex]) {
			var _updated = f.date.fromstring(updated, true) / 1000 //todo check, utc

			return storages[dbindex].invalidate(_updated, data)
		}

		return Promise.reject("empty Storage")
	}

	self.clearCache = function () {
		var keys = []

		_.each(cache, function (c, i) {
			keys.push(i)
		})

		_.each(storages, function (c, i) {
			keys.push(i)
		})

		_.each(liststorage, function (c, i) {
			keys.push(i)
		})

		keys = _.uniq(keys)

		_.each(keys, function (k) {
			self.clearCacheKey(k)
		})

	}

	self.clearCacheKey = function (key) {

		if (cache[key]) delete cache[key]

		if (liststorage[key]) delete liststorage[key]

		if (storages[key]) {


			try{
				storages[key].clearall().catch(e => { console.error(e) })
			}

			catch(e){
				
			}
			delete storages[key]
		}
	}

	self.checkUpdates = function () {
		return Promise.resolve()
	}

	self.invalidateStorageNow = function (type) {
		var inv = [{
			updated: f.date.nowUtc1000(),
			type
		}]

		return invalidateStorage(inv)
	}

	self.invalidateStorageAll = function(){
		_.each(dbmeta, (f, k) => {
			self.invalidateStorageNow([k])
		})
	}

	

	self.common = {
		search: function (value) {
			var apis = {
				
			}

			var result = {}

			return Promise.all(_.map(apis, (action, i) => {

				return action.then(r => {
					result[i] = r
				})

			})).then(r => {
				return Promise.resolve(result)
			})
		}
	}

	
	self.sharing = {
		create : function(type, info, p = {}){
			var data = {
				Id : sha1(type + JSON.stringify(info)),
				Info : JSON.stringify({
					info, type
				})
			};

			return request(data, 'api', 'userdata/PublicSettings/create', {
				method: "POST"
			}).then((d) => {
				return (p.url) + d.Id;
			})
			
		},

		get : function(id){
			return request({}, 'api', 'userdata/PublicSettings/get/' + id, {
				method: "GET"
			}).then((d) => {

				if(!d.Info) return Promise.reject('notfound')

				var data = null

				try{
					data = JSON.parse(d.Info);
				} catch(e){
					return Promise.reject('notfound')
				}

				return Promise.resolve(data)
			})
		}
	}

	//////////////

	self.app = {
		info : function(p = {}){
			
			p.storageparameters = dbmeta.system();

			return request({}, 'api', 'app/info', p)
		},

		wallpapers: function(p = {}){
			
			p.storageparameters = dbmeta.system();

			return request({}, 'api', 'app/getwallpapers', p).then(files => {


				return Promise.resolve(_.map(files, (f) => {
					return address + '/' + f
				}))
			})
		},
	}

	self.sync = {
		request : function(payload, p){

			/*var payload = {
				date : new Date()
			}*/

			return request(payload, 'api', 'sync', {
				...p,
				timeout : 61000
			})
		}
	}

	self.news = {
		admin : {
			run : function(p){
				return request({}, 'api', 'admin/snippity/runNewsLetterIteration', p).then(d => {
					return Promise.resolve(d)
				})
			},

			runprocess : function(p){
				return request({}, 'api', 'admin/snippity/runNewsLetterIterationProcess', p).then(d => {
					return self.app.info({refreshDb : true})
				})
			},

			stopprocess : function(p){
				return request({}, 'api', 'admin/snippity/stopNewsLetterIterationProcess', p).then(d => {
					return self.app.info({refreshDb : true})
				})
			},
		}
	}

	self.lessons = {
		catalog : function({locale, age}, p = {}){
			p.storageparameters = dbmeta.lessonslight();

			return request({locale, age}, 'api', 'snippity/lessons/catalog', p).then(d => {

				return Promise.resolve(d)
			})

		},
		list : function(data = {}, p = {}){
			p.storageparameters = dbmeta.lessons();

			p.method = "POST"
			p.count = 'pageSize'
			p.from = 'pageNumber'
			p.bypages = true
			p.includeCount = "includeCount"

			p.kit = {
				class: Lesson,
				path: 'records',
			}

			return paginatedrequest(data, 'api', 'snippity/lessons/list', p)
		},

		create : function(topic, p){
			return request({topic}, 'api', 'snippity/lessons/create', p).then(d => {
				return Promise.resolve(d)
			}).catch(e => {
				return Promise.reject(e.error || 'undefined')
			})
		},

		getTokens : function(p){
			return request({}, 'api', 'snippity/lessons/tokens', p).then(d => {
				return Promise.resolve(d)
			})
		},

		get : function(uid, p = {}){

			p.storageparameters = dbmeta.lessons();
			

			return request({uid}, 'api', 'snippity/lessons/get', p).then(d => {

				var lesson = new Lesson(d)

				//story.uid = uid

				return Promise.resolve(lesson)
			})

		},

		

		join : {
            set : function(uid, p = {}){

                return request({uid}, 'api', 'snippity/lessons/join/set', p).then(d => {

					core.vxstorage.invalidate(uid, 'progress')
					self.invalidateStorageNow(['progress'])

					return Promise.resolve(d)
				}).then(() => {
					return self.lessons.progress.get(uid)
				})

            },

            get : function(uids, p = {}){

                return request({uids}, 'api', 'snippity/lessons/join/get', p).then(d => {
					return Promise.resolve(d)
				}).catch(e => {
					if(e == 'empty'){
						return Promise.resolve(null)
					}

					return Promise.reject(e)
				})
            },

			cancel : function(uid, p){
				return request({uid}, 'api', 'snippity/lessons/join/cancel', p).then(d => {

					core.vxstorage.invalidate(uid, 'progress')
					self.invalidateStorageNow(['progress'])

					return Promise.resolve(d)
				}).then(() => {
					return self.lessons.progress.get(uid)
				})
			}
        },

        progress : {
            get : function(uids, p = {}){

				if(!_.isArray(uids)) uids = [uids]

				p.storageparameters = dbmeta.progress();

				p.kit = {
					class: LessonProgress,
				}

				p.vxstorage = {
					type: 'progress',
					index : 'uid',
				}

                return request({uids}, 'api', 'snippity/lessons/progress/get', p).then(d => {
					return Promise.resolve(d)
				})

            },

            set : function(uid, index, grade, p = {}){
                return request({uid, index, grade}, 'api', 'snippity/lessons/progress/set', p).then(d => {

					core.vxstorage.invalidate(uid, 'progress')
					self.invalidateStorageNow(['progress'])

					return Promise.resolve(d)
				}).then(() => {
					return self.lessons.progress.get(uid)
				})
                
            },

			getByLessons : function(lessons, p = {}){

				if(!_.isArray(lessons)) lessons = [lessons]

				return self.lessons.progress.get(_.map(lessons, (l) => {
					return l.uid
				}), p)

			}
        },

		admin : {
			setToken : function(userId, p){
				return request({userId}, 'api', 'admin/lessons/token/add', p).then(d => {
					return Promise.resolve(d)
				})
			},

			create : function(locale, topic, ageCluster, p){
				return request({locale, topic, ageCluster}, 'api', 'admin/lessons/create', p).then(d => {
					return Promise.resolve(d)
				}).catch(e => {
					return Promise.reject(e.error || 'undefined')
				})
			},

			createlesson : function(uid, index, key = '', p){
				return request({uid, index, key}, 'api', 'admin/lessons/create/lesson', p).then(d => {
					return Promise.resolve(d)
				}).catch(e => {
					return Promise.reject(e.error || 'undefined')
				})
			},

			removereturn: function(uid, bit, p){
				return request({uid, bit}, 'api', 'admin/lessons/removereturn', p).then(d => {

					self.invalidateStorageNow(['lessons'])

					return Promise.resolve(d)
				}).catch(e => {
					return Promise.reject(e.error || 'undefined')
				})
			},
			
		}
	}

	self.stories = {
		canGetStoryToMe: function(p = {}){

			p.storageparameters = dbmeta.stories();

			return request({}, 'api', 'snippity/story/cangetany', p).then(d => {

				return Promise.resolve(d.data)
			})
		},
		sendAnyStoryToMe : function(payload, p){
			return request(payload, 'api', 'snippity/story/sendany', p).then(d => {
				return Promise.resolve(d)
			})
		},
		gets : function(ids, p){

			return Promise.all(_.map(ids, (id) => {

				return self.stories.get(id, p).then((r) => {
					result[id] = r
				})

			})).then(() => {
				return Promise.resolve(result)
			})

			/*var result = {}
			if (!ids.length) return Promise.resolve(result)

			p.storageparameters = dbmeta.stories();

			p.storageparameters.divide = {
				requestIndex: 'uids',
				getloaded: 'uid',
				path: 'records'
			}

			return request({uids : ids}, 'api', 'snippity/story/gets', p).then(d => {

				var story = new Story(d.data, address)

				story.uid = uid

				return Promise.resolve(story)
			})*/

			/*return Promise.all(_.map(ids, (id) => {

				return self.stories.get(id, p).then((r) => {
					result[id] = r
				})

			})).then(() => {
				return Promise.resolve(result)
			})*/
		},
		view : function(uid, p = {}){
			return request({uid}, 'api', 'snippity/story/view', p).then(d => {
				return Promise.resolve(d)
			})
		},

		viewua : function(uid, p = {}){
			return request({uid}, 'api', 'snippity/story/viewua', p).then(d => {
				return Promise.resolve(d)
			})
		},

		views : function(uids, p = {}){
			return request({uids}, 'api', 'snippity/story/views/get', p).then(d => {
				return Promise.resolve(d)
			})
		},

		getmyviews : function(p = {}){
			return request({}, 'api', 'snippity/story/views/getmy', p).then(d => {
				return Promise.resolve(d)
			})
		},

		reaction : function(uid, value, p = {}){
			return request({uid, value}, 'api', 'snippity/story/reaction', p).then(d => {
				return Promise.resolve(d)

			})
		},

		reactions : function(uids, p = {}){

			p.vxstorage = {
				type: 'reaction',
				index : 'story'
			}

			return request({uids}, 'api', 'snippity/story/reactions/get', p).then(d => {
				return Promise.resolve(d)
			})
		},

		get : function(uid, p = {}){

			p.storageparameters = dbmeta.stories();

			return request({uid}, 'api', 'snippity/story/get', p).then(d => {

				var story = new Story(d.data, address)

				story.uid = uid

				return Promise.resolve(story)
			})

		}
	}

	self.chat = {
		send : function(events){
			return request({events}, 'api', 'chat/send')
		},
		getEvents : function(roomid, from, count){
			return request({roomid, from, count}, 'api', 'chat/events/get')
		},

		create : {
			support : function(p){
				return request({}, 'api', 'chat/create/support', p)
			}
		}
	}

	self.notifications = {
		register: function ({ token, device }, p = {}) {

			p.method = "POST"

			return request({ token: token, device, appid: self.appid }, 'api', 'notifications/register', p).then(r => {
				return Promise.resolve()
			})

		},

		revoke: function ({ device }, p = {}) {

			p.method = "POST"

			return request({ device, appid: self.appid }, 'api', 'notifications/revoke', p).then(r => {
				return Promise.resolve()
			})

		}
	}

	self.moderation = {
		list : function(data = {}, p = {}){

			p.method = "POST"
			p.count = 'pageSize'
			p.from = 'pageNumber'
			p.bypages = true
			p.includeCount = "includeCount"

			p.kit = {
				class: Task,
				path: 'records',
			}

			return paginatedrequest(data, 'api', 'admin/moderation/list', p)

		},

		taskdata : function(uid){
			return request({uid}, 'api', 'admin/moderation/data').then((d) => {

				if (d.story){
					d._story = new Story(d.story, address)
				}

				
				return Promise.resolve(d)
			})
		},

		redo: function(uid, from){
			return request({uid, now : true, from}, 'api', 'admin/moderation/redo').then((d) => {
				return Promise.resolve(d)
			})
		},

		approve: function(uid){
			return request({uid, status : 'approve'}, 'api', 'admin/moderation/result').then((d) => {
				return Promise.resolve(d)
			})
		},

		cancel : function(uid){

			return request({uid}, 'api', 'admin/moderation/cancel').then((d) => {
				return Promise.resolve(d)
			})
			
		},

		createVideo : function(id){
			return request({id}, 'api', 'admin/moderation/createVideoForStory').then((d) => {
				return Promise.resolve(d)
			})
		}

	}

	self.payments = {

		demo : function(id, period){
			return request({id, period}, 'api', 'admin/payments/demo')
		},

		identity : function(payload){
			return request(payload, 'api', 'payments/identity')
		},
		userplans: function(){
			return request({}, 'api', 'payments/userplans')
		},

		checkpromo: function(data){
			return request(data, 'api', 'payments/checkpromo').then((d) => {
				return Promise.resolve(d.promo)
			})
		},

		cancelSubscription: function(){
			return request({}, 'api', 'payments/cancel/subscription')
		},

		promo : {
			list : function(data = {}, p = {}){

				p.method = "POST"
				p.count = 'pageSize'
				p.from = 'pageNumber'
				p.bypages = true
				p.includeCount = "includeCount"

				p.kit = {
					class: Promocode,
					path: 'records',
				}

				return paginatedrequest(data, 'api', 'payments/promo/list', p)
	
			},
			addcode : function(data = {}, p = {}){
				return request(data, 'api', 'payments/promo/addcode')
			},

			codeusage :  function(d, p = {}){

				//p.storageparameters = dbmeta.earnings();

				return request(d, 'api', 'payments/promo/codeusage', p)
			},
		},

		admin : {
			list : function(data = {}, p = {}){

				p.method = "POST"
				p.count = 'pageSize'
				p.from = 'pageNumber'
				p.bypages = true
				p.includeCount = "includeCount"

				return paginatedrequest(data, 'api', 'admin/payments/list', p)
	
			},

			refund : function(data, p = {}){
				return request(data, 'api', 'admin/payments/refund', p)
			}
		},

		notifyapple : function(transaction){
			return request({transaction}, 'api', 'payments/apple/success')
		}
	}

	self.admin = {
		seo : function(p = {}){
			return request({}, 'api', 'admin/seo/sitemap/create', p).then(d => {
				return Promise.resolve(d)
			})
		}
	}

	self.user = {

		link: function (payload) {
			return request(payload, 'api', 'user/link')
		},

		remove: function () {
			return request({}, 'api', 'user/remove')
		},

		signin: function (payload) {
			
			payload.ios = f.isios()

			return request(payload, 'api', 'user/signinv2')
		},

		infoEdit: function (payload) {
			return request(payload, 'api', 'user/info/commonEdit')
		},

		register : function(data){
			return request(data, 'api', 'user/create', {
				method: "POST"
			})
		},

		typechange : function(type){
			return request({type}, 'api', 'user/typechange', {
				method: "POST"
			})
		},

		getpictures: function(){
			return request({}, 'api', 'user/getpictures', {
				method: "POST"
			}).then(pics => {
				return Promise.resolve(_.map(pics, (f) => {
					return address + '/' + f
				}))
			})
		},

		setpicture: function(path){
			return request({path}, 'api', 'user/setpicture', {
				method: "POST"
			})
		},

		///
		

	

		/*changePassword: function ({ password, pin }, p = {}) {

			return request({

				NewPassword: password,
				Pin: pin

			}, 'api', 'userdata/user/PreChangePassword', p)

		},*/

		confirmation : {
			email : {
				request :  function (p = {}) {
					return request({}, 'api', 'user/email/requestConfirm', p)
				},
				confirm :  function (hash, p = {}) {
					return request({
						hash,
					}, 'api', 'user/email/confirm', p)
				},
			}
		},
		

		restorePassword: function ({ email }, p = {}) {
			return request({
				login: email,
			}, 'api', 'user/password/requestrestore', p)
		},

		restorePasswordContinue: function ({ hash, pwdhash }, p = {}) {
			return request({
				hash: hash,
				pwdhash: pwdhash
			}, 'api', 'user/password/setnew', p)
		}
	}

	self.partner = {
		getInfo : function(p = {}){
			return request({}, 'api', 'partner/info/get', p)
		},

		updateInfo : function({paymentinfo, info}, p){
			return request({paymentinfo, info}, 'api', 'partner/info/update', p)
		},
	}

	self.autoupdater = {
		getLatest : function(p = {}){

			return Axios({
				baseURL: 'https://api.github.com/repos/snippity/releases/releases/latest',
				method: 'get'
			}).then((r) => {
				return Promise.resolve(r.data)
			})

		}
	}

	self.team = {
		users : {
			list : function(data = {}, p = {}){

				p.method = "POST"
				p.count = 'pageSize'
				p.from = 'pageNumber'
				p.bypages = true
				p.includeCount = "includeCount"

				return paginatedrequest(data, 'api', 'team/users/list', p)
	
			},

			changeType : function({id, type}, p){
				return request({id, type}, 'api', 'team/users/changetype', p)
			}
		},

		partner : {
			verify : function(userid, p = {}){
				return request({userid}, 'api', 'team/partner/verify', p)
			},

			unverify : function(userid, p = {}){
				return request({userid}, 'api', 'team/partner/unverify', p)
			},

			getInfo : function(userid, p = {}){
				return request({userid}, 'api', 'team/partner/info', p)
			},

			updateInfo : function({userid, paymentinfo, info}, p = {}){
				return request({userid, paymentinfo, info}, 'api', 'team/partner/info/update', p)
			},
		},

		promo : {
			codeusage :  function(d, p = {}){

				//p.storageparameters = dbmeta.earnings();

				return request(d, 'api', 'team/promo/codeusage', p)
			},
			list : function(data = {}, p = {}){

				p.method = "POST"
				p.count = 'pageSize'
				p.from = 'pageNumber'
				p.bypages = true
				p.includeCount = "includeCount"

				p.kit = {
					class: Promocode,
					path: 'records',
				}

				return paginatedrequest(data, 'api', 'team/promo/list', p)
	
			},
		}
	}

	self.kit = {
		file : (id, key, type) => { 
			return address + '/res/files?id=' + id + '&key=' + key + '&type=' + type
		}
	}
	

	self.paginatedrequest = paginatedrequest
	self.request = request

	return self;
}

export default ApiWrapper

